<template>
    <div>
        <b-modal id="modalDescarte" data-backdrop="static" data-keyboard="false" centered
            :title="this.$t('Descarte Pneus')">

            <div class="container">
                <span><strong>{{ $t('Selecione um fornecedor') }}</strong>:</span>
                <p>{{ $t('Comece a digitar o nome do fornecedor para exibir na lista abaixo') }}</p>
                <v-select :filterable="false" :options="fornecedores" :placeholder="$t('Digite para pesquisar')" v-model="form.fornecedor" @search="onSearch">
                </v-select>
            </div>

            <div class="container mt-4">
                <span><strong>{{ $t('Selecione um motivo') }}</strong>:</span>
                <v-select :options="motivos" v-model="form.motivos">
                </v-select>
            </div>

            <div class="container mt-4">
                <span><strong>{{ $t('Observação') }}</strong>:</span>

                <input class="form-control" type="text" v-model="form.observacao">
            </div>

            <div class="container mt-4">
                <span><strong>{{ $t('Data') }}</strong>:</span>

                <input class="form-control" type="date" id="dataDescarte" v-model="dataDescarte">

            </div>

            <div class="container mt-4">
                <span><strong>{{ $t('Anexar documento') }}</strong>:</span>
                <p>{{ $t('Selecione o tipo do documento e o arquivo para anexar ao descarte') }}</p>

                <v-select :options="tiposDocumento" :placeholder="$t('Tipo de documento')" v-model="documento.tipo">
                </v-select>

                <upload-arquivos class="mt-2" ref="uploadDescarte" store-module="borracharia"
                    input-id="formFilesDescarte" :extensoes="extensoesPermitidas" :tamanho-maximo="tamanhoMaximo"
                    :upload-action="null"></upload-arquivos>

                <b-button class="mt-2" variant="primary" block @click="adicionarDocumento()">
                    <i class="fa fa-paperclip" aria-hidden="true" style="margin-right: 8px"></i>{{ $t('Adicionar documento') }}
                </b-button>

                <ul class="list-group mt-2" v-if="documentos.length">
                    <li class="list-group-item d-flex justify-content-between align-items-center"
                        v-for="(anexo, index) in documentos" :key="index">
                        <span>
                            <strong>{{ anexo.tipo.label }}</strong><br>
                            <small>{{ anexo.arquivo.name }}</small>
                        </span>
                        <b-button variant="danger" size="sm" @click="removerDocumento(index)">
                            <i class="fa fa-trash" aria-hidden="true"></i>
                        </b-button>
                    </li>
                </ul>
            </div>

            <template #modal-footer="{ cancel }">
                <div class="w-100">
                    <div class="row center" style="justify-content: center;">
                        <b-button class="mr-2" variant="danger" size="lg" @click="cancel(), modalShow = false, limparFormulario()">
                            {{ $t('Fechar') }}
                        </b-button>
                        <b-button class="mr-2" variant="success" size="lg" @click="realizarDescarte()">
                            <i class="fa fa-recycle" aria-hidden="true" style="margin-right: 8px"></i>{{ $t('Descartar') }}
                        </b-button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>

const EXTENSOES_PERMITIDAS = ['jpg', 'jpeg', 'png', 'pdf', 'txt', 'doc', 'docx', 'zip', 'rar']
const TAMANHO_MAXIMO = 8 * 1024 * 1024 // 8MB

import UploadArquivos from '../Modais/UploadArquivos.vue';

export default {
    name: "ModalExterna",

    components: {
        UploadArquivos
    },

    data() {
        return {
            dataDescarte: this.getCurrentDate(), // Define a data atual como valor padrão
            form: {},
            documento: { tipo: null },
            documentos: [],
            extensoesPermitidas: EXTENSOES_PERMITIDAS,
            tamanhoMaximo: TAMANHO_MAXIMO
        };
    },

    created(){
        this.$store.dispatch('borracharia/getFromDescarte')
        this.$store.dispatch('borracharia/getFornecedoresDescartes')
        this.$store.dispatch('borracharia/getTiposDocumentoDescarte')
    },

    props: {
        pneu: {}
    },

    computed: {
        fornecedores() {
            const fornecedores = this.$store.getters['borracharia/getFornecedores']

            if (!fornecedores || !fornecedores.length) {
                return []
            }

            return fornecedores.map(fornecedor => {
                return {
                    ...fornecedor,
                    label: fornecedor.ds_fornecedor
                }
            })
        },
        motivos() {
            const motivos = this.$store.getters['borracharia/getMotivos']

            if (!motivos || !motivos.length) {
                return []
            }

            return motivos.map(motivo => {
                return {
                    ...motivo,
                    label: motivo.ds_motivo
                }
            })
        },
        tiposDocumento() {
            const tipos = this.$store.getters['borracharia/getTiposDocumento']

            if (!tipos) {
                return []
            }

            return tipos.map(tipo => {
                return {
                    ...tipo,
                    label: tipo.ds_documento
                }
            })
        },
    },
    methods: {
        onSearch(search) {
            console.log(search)
            // Aqui chamamos o Vuex action para buscar os fornecedores com base no input
            // this.searchQuery = search;
            this.fetchFornecedores(search);
        },

        async fetchFornecedores(searchQuery) {
            this.loading = true;
            try {
                await this.$store.dispatch('borracharia/getFornecedoresDescartes', searchQuery);
            } catch (error) {
                console.error("Erro ao buscar fornecedores", error);
            } finally {
                this.loading = false;
            }
        },

        adicionarDocumento() {
            if (!this.documento.tipo) {
                this.$swal.fire({
                    title: this.$t('Oops!'),
                    text: this.$t('Informe o tipo do documento'),
                    icon: 'warning'
                })

                return
            }

            const arquivos = this.$store.state.borracharia.filesUpload

            if (!arquivos || !arquivos.length) {
                this.$swal.fire({
                    title: this.$t('Oops!'),
                    text: this.$t('Selecione um anexo'),
                    icon: 'warning'
                })

                return
            }

            arquivos.forEach(arquivo => {
                this.documentos.push({
                    tipo: this.documento.tipo,
                    arquivo: arquivo
                })
            })

            this.documento.tipo = null
            this.limparCampoArquivo()
        },

        removerDocumento(index) {
            this.documentos.splice(index, 1)
        },

        limparCampoArquivo() {
            if (this.$refs.uploadDescarte) {
                this.$refs.uploadDescarte.limparArquivos()
            }
        },

        limparFormulario() {
            this.form = {}
            this.documento.tipo = null
            this.documentos = []
            this.limparCampoArquivo()
        },

        async enviarDocumentos() {
            const falhas = []

            for (const anexo of this.documentos) {
                const formData = new FormData()

                formData.append('documento', anexo.arquivo)
                formData.append('tp_documento', anexo.tipo.tp_documento)
                formData.append('pneu', this.pneu.cd_pneu)

                try {
                    await this.$store.dispatch('borracharia/uploadDocumentoDescarte', { data: formData })
                } catch (error) {
                    console.error("Erro ao anexar documento", error)
                    falhas.push(anexo.arquivo.name)
                }
            }

            return falhas
        },

        async realizarDescarte() {
            const data = {
                fornecedor: this.form.fornecedor.nr_sequencial,
                motivos: this.form.motivos.cd_motivo,
                observacao: this.form.observacao,
                data: this.dataDescarte,
                pneu: this.pneu
            }

            try {
                await this.$store.dispatch('borracharia/postDescarte', { data: data })
            } catch (error) {
                const message = (error.response && error.response.data && error.response.data.message)
                    ? error.response.data.message
                    : (error.message || this.$t('Erro ao descartar pneu, tente novamente!'))

                this.$swal.fire({
                    title: this.$t('Oops!'),
                    text: message,
                    icon: 'error'
                })

                return
            }

            const falhas = await this.enviarDocumentos()

            if (falhas.length) {
                this.$swal.fire({
                    title: this.$t('Oops!'),
                    text: `${this.$t('Descarte realizado, mas falhou o envio dos anexos')}: ${falhas.join(', ')}`,
                    icon: 'warning'
                })
            } else {
                this.$swal.fire({
                    title: this.$t('Sucesso!'),
                    text: this.$t('Descarte realizado com sucesso!'),
                    icon: 'success'
                })
            }

            this.limparFormulario()
            this.$store.dispatch('borracharia/fetchPlacasDescartes', {})
            this.$bvModal.hide('modalDescarte')
        },

        getCurrentDate() {
            const now = new Date();
            // Formata a data para o formato 'yyyy-MM-dd' aceito pelo input tipo date
            return now.toISOString().slice(0, 10);
        }
    }

}
</script>

<style src="./style.css" />
